import { Fragment } from 'react';
import { Grid } from '@mui/material';

import MuiTable from './MuiTable';
import { IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';
import useTableForm from '../hooks/useTableForm';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
}

const BodyStatus = (props: Props) => {
  const { radioGroup } = useTableForm(props);

  const columns = [
    { fieldId: 'title', label: '身體狀況' },
    {
      fieldId: '0',
      label: '完全需要幫助',
      sx: { textAlign: 'center' },
    },
    { fieldId: '1', label: '部分需要幫助', sx: { textAlign: 'center' } },
    {
      fieldId: '2',
      label: '完全獨立',
      sx: { textAlign: 'center' },
    },
  ];

  const rows = [
    {
      id: 'takeOffClothes',
      title: '脫衣服 / 穿衣服',
      ...radioGroup({
        key: 'body_status.takeOffClothes',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'eat',
      title: '進食',
      ...radioGroup({
        key: 'body_status.eat',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'sitUp',
      title: '坐起來',
      ...radioGroup({
        key: 'body_status.sitUp',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'toilet',
      title: '使用浴室',
      ...radioGroup({
        key: 'body_status.toilet',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'washFace',
      title: '洗臉',
      ...radioGroup({
        key: 'body_status.washFace',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'bath',
      title: '洗澡',
      ...radioGroup({
        key: 'body_status.bath',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'transfer',
      title: '換座位',
      ...radioGroup({
        key: 'body_status.transfer',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'controlStool',
      title: '控制排便',
      ...radioGroup({
        key: 'body_status.controlStool',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'brushTeeth',
      title: '刷牙',
      ...radioGroup({
        key: 'body_status.brushTeeth',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'changePosition',
      title: '改變姿勢',
      ...radioGroup({
        key: 'body_status.changePosition',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'getOutRoom',
      title: '離開房間',
      ...radioGroup({
        key: 'body_status.getOutRoom',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'controlUrine',
      title: '控制排尿',
      ...radioGroup({
        key: 'body_status.controlUrine',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
  ];

  return (
    <Fragment>
      <SectionTitle title="身體狀況（執行日常生活活動的能力） " />
      <Grid item xs={12}>
        <MuiTable columns={columns} rows={rows} />
      </Grid>
    </Fragment>
  );
};

export default BodyStatus;
